export default __webpack_public_path__ + "static/audiobitehighlight-ce643ab696ccf1ea624365b44b8ca79a.png";